import React from "react";
import { Modal, Row, Col, Form, notification } from "antd";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { withGlobal } from "../../../../component-global";
import { resetPasswordAndSendEmailAccount } from "../../../../graphQl/mutations/affiliate";
import { AGENCY_PORTAL_CLASS } from "./style";

class ModalSendAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingButtons: false,
      newPassword: "",
    };
  }

  componentDidMount() {
    const { password } = this.props;

    if (!password)
      this.setState({ newPassword: this.generatePassword() }, () => {
        this.mutationGeneratePassword();
      });
  }

  generatePassword = () => {
    const length = 8;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let password = "";

    for (let i = 0; i < length; i++)
      password += charset.charAt(Math.floor(Math.random() * charset.length));

    return password;
  };

  mutationGeneratePassword = () => {
    const { onHandleCancelModal, userID } = this.props;
    const { newPassword } = this.state;

    try {
      const variables = {
        userID,
        password: newPassword,
      };
      this.setState({ loadingButtons: true });
      this.props.client
        .mutate({
          mutation: resetPasswordAndSendEmailAccount,
          update: (
            cache,
            { data: { resetPasswordAndSendEmailAccount: response } }
          ) => {
            this.setState({ loadingButtons: false });
            // si se genero la contraseña el modal queda abierto para que el
            // usuario pueda verla; si fallo se cierra porque no es valida
            if (response.statusCode === 200) {
              notification.success({ message: response.message });
            } else {
              notification.error({ message: response.message });
              onHandleCancelModal();
            }
          },
          variables,
        })
        .catch(() => {
          this.setState({ loadingButtons: false });
          notification.error({
            message: "Hubo un error al actualizar los datos.",
          });
          onHandleCancelModal();
        });
    } catch (err) {
      this.setState({ loadingButtons: false });
      notification.error({
        message: "Hubo un error al actualizar los datos.",
      });
      onHandleCancelModal();
    }
  };

  closeModal = () => {
    const { onHandleCancelModal } = this.props;
    const { loadingButtons } = this.state;
    if (!loadingButtons) onHandleCancelModal();
  };

  render() {
    const { visible, names, email, password } = this.props;
    const { newPassword } = this.state;

    return (
      <Modal
        title={null}
        visible={visible}
        footer={null}
        onCancel={this.closeModal}
        width="420px"
        centered
        wrapClassName={AGENCY_PORTAL_CLASS}
        bodyStyle={{ padding: 45, fontFamily: "Gilroy, sans-serif" }}
      >
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontFamily: "Gilroy, sans-serif",
              fontWeight: "bold",
              fontSize: "24px",
              lineHeight: "32px",
              textAlign: "center",
              color: "#595959",
              marginBottom: 20,
            }}
          >
            {names} se registró con éxito
          </p>
        </div>
        <Row gutter={16} style={{ marginBottom: 15 }}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            style={{ marginBottom: 0 }}
          >
            <table
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                fontFamily: "Gilroy, sans-serif",
              }}
            >
              <tbody>
                <tr>
                  <td style={{ textAlign: "left", paddingRight: 15 }}>
                    <b>Usuario: </b>
                  </td>
                  <td style={{ textAlign: "left" }}>{email}</td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", paddingRight: 15 }}>
                    <b>Contraseña: </b>
                  </td>
                  <td style={{ textAlign: "left" }}>
                    {password || newPassword}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontFamily: "Gilroy, sans-serif",
              fontWeight: "bold",
              fontSize: "12px",
              lineHeight: "10px",
              textAlign: "center",
              color: "#595959",
              margin: "0px",
            }}
          >
            A {names} se le {password ? "enviaron" : "enviarán"} sus datos por
            correo
          </p>
        </div>
      </Modal>
    );
  }
}

const WrapperModalSendAccount = withGlobal(ModalSendAccount);
const ModalSendAccountForm = Form.create()(WrapperModalSendAccount);

export default compose(withApollo)(ModalSendAccountForm);
